import * as t from 'io-ts';

export const AnalysisAvailabilitySchema = t.keyof({
    CONTRACTUAL: null,
    NON_CONTRACTUAL: null,
    ALL: null,
});

export type AnalysisAvailability = t.TypeOf<typeof AnalysisAvailabilitySchema>;
